























import {
  computed,
  defineComponent,
  PropType
} from '@vue/composition-api'

import teliaColors from '@teliads/components/foundations/colors/variables'
import { Asset } from 'contentful'
import { CfAnslHeroBanner } from '@/types/ansl-space/types/cf-ansl-hero-banner'

type Content = {
  title: string;
  description: string;
  backgroundImage: string | Asset;
}

export default defineComponent({
  props: {
    content: {
      type: Object as PropType<Content | CfAnslHeroBanner>,
      required: true
    }
  },
  setup ({ content }) {
    const backgroundImageProxy = computed(() => {
      const backgroundImage = content.backgroundImage
      if (typeof backgroundImage === 'object' && backgroundImage !== null) {
        return backgroundImage.fields.file.url
      }

      return backgroundImage
    })

    return {
      teliaColors,
      backgroundImageProxy
    }
  }
})

